import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import DataBreakdown from "./data-breakdown";
import ListView from "./list-view/ListView";
import { ReactComponent as BlueBullet } from "assets/svg/blue-bullet.svg";
import { ReactComponent as LightBlueBullet } from "assets/svg/light-blue-bullet.svg";
import { ReactComponent as OrangeBullet } from "assets/svg/orange-bullet.svg";
import styles from "./styles.module.scss";
import { AmplitudePageName, track } from "utils/amplitude";

interface Props {
  amplitudePageName: AmplitudePageName;
}

const AMPLITUDE_COMPONENT_NAME = "session-lists";

const Sessions: React.FC<Props> = ({ amplitudePageName }) => {
  return (
    <div className={styles["session-list"]}>
      <DataBreakdown />

      <Tabs
        defaultActiveKey={"completed-session"}
        id="uncontrolled-tab"
        className={styles["session-list__tabs"]}
      >
        <Tab
          eventKey="completed-session"
          title={
            <span className={styles["session-list__tab-title"]}>
              <BlueBullet />
              Completed sessions
            </span>
          }
          onEnter={() =>
            track(
              amplitudePageName,
              [AMPLITUDE_COMPONENT_NAME, "completed-sessions-tab"],
              "click",
            )
          }
        >
          <ListView
            showPast={true}
            amplitudePageName={amplitudePageName}
            amplitudeComponentName={AMPLITUDE_COMPONENT_NAME}
          />
        </Tab>
        <Tab
          onEnter={() =>
            track(
              amplitudePageName,
              [AMPLITUDE_COMPONENT_NAME, "upcoming-sessions-tab"],
              "click",
            )
          }
          eventKey="upcoming-session"
          title={
            <span className={styles["session-list__tab-title"]}>
              <LightBlueBullet />
              Upcoming sessions
            </span>
          }
        >
          <ListView
            showPast={false}
            amplitudePageName={amplitudePageName}
            amplitudeComponentName={AMPLITUDE_COMPONENT_NAME}
          />
        </Tab>

        <Tab
          eventKey="cancelled-session"
          title={
            <span className={styles["session-list__tab-title"]}>
              <OrangeBullet />
              Cancelled sessions
            </span>
          }
          onEnter={() =>
            track(
              amplitudePageName,
              [AMPLITUDE_COMPONENT_NAME, "cancelled-sessions-tab"],
              "click",
            )
          }
        >
          <ListView
            showCancelled={true}
            amplitudePageName={amplitudePageName}
            amplitudeComponentName={AMPLITUDE_COMPONENT_NAME}
          />
        </Tab>
      </Tabs>
    </div>
  );
};

export default Sessions;
